<div
  class="network"
  [class.--is-desktop]="isDesktop"
  [class.--is-mobile]="isMobile"
  [class.--is-within-webview]="isWithinWebView"
  [class.--is-instagram-browser]="isInstagramBrowser"
  [class.--floating-transparent-menu]="isFloatingTransparentMenu"
>

  <!-- DESKTOP TOP BAR -->
  <mip-top-menu-bar *ngIf="isDesktop"></mip-top-menu-bar>

  <!-- NETWORK CONTENT -->
  <div #networkContainer class="__container">
    <mat-drawer-container #drawerContainer [hasBackdrop]="!isDesktop">
      <!-- SIDE MENU -->
      <mat-drawer #drawer [mode]="isDesktop ? 'side' : 'push'" [position]="isDesktop ? 'start' : 'end'" [opened]="isDesktop">
        <mip-side-menu></mip-side-menu>
      </mat-drawer>

      <!-- PAGE CONTENT -->
      <mat-drawer-content>
        <div class="__drawer-content">
          <router-outlet></router-outlet>
        </div>
      </mat-drawer-content>
    </mat-drawer-container>
  </div>
</div>

<mip-main-menu-bar
  class="__main-menu-bar"
  [settings]="menuBarSettings"
  *ngIf="hideMenuBar !== true && isMobile && isWithinWebView === false"
></mip-main-menu-bar>
